import { styled } from "@mui/material";

export const EmptyStateBox = styled("section")(({ theme }) => ({
  width: "100%",
//   minHeight: "60vh",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#ffffff",

  "& .textContainer": {
    width: "380px",
    textAlign: "center",

    "& .details": {
      color: "#939393",
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "24px",
      margin: "0.5rem 0 1.5rem",
    },

    "@media (max-width: 991.9px": {
      width: "500px",
    },

    "@media (max-width: 767.9px": {
      width: "85%",
    },

    "@media (max-width: 567.9px": {
      "& .details": {
        fontSize: "0.875rem",
        margin: "2rem 0",
      },
    },
  },
}));
